import React, { useEffect, useMemo, useState, useCallback } from "react";
import CardsBorder from "../../../components/Cards/CardsBorder";
import { Tables } from "../../../components/Elements/Tables/Tables";
import SearchBar from "../../../components/Elements/Search/SearchBar";
import TextStyles from "../../../components/Elements/TextStyles/TextStyles";
import { ReactComponent as GreenEye } from "../../../assets/svgs/greenEye.svg";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import { getApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";
import { formatDate, convertRoleType } from "../../../utils/UtilService";
import { useNavigate } from "react-router-dom";

const StandardForms = ({ clientId, projectId }) => {
  const navigate = useNavigate();
  const [searchItem, setSearchItem] = useState("");
  const [tableData, setTableData] = useState([]);
  const [pageNo, setPageNo]=useState(1);
  const[pageSize, setPageSize]=useState(10);
  const[totalRecords, setTotalRecords]=useState("")
  const headers = useMemo(
    () => [
      { label: "Sr. No.", key: "serial" },
      { label: "Form Title", key: "formTitle" },
      { label: "Assigned On", key: "assignedOn" },
      { label: "Role Type", key: "roleType" },
      { label: "Action", key: "action" },
    ],
    []
  );

  // const tableData = useMemo(() => [
  //   {
  //     serial: 1,
  //     formTitle: "BASIC DETAILS FORM",
  //     assignedOn: "01/02/2023",
  //     roleType: "Employee, Vendor",
  //     action: (
  //       <div className="flex gap-2">
  //         <GreenEye />
  //       </div>
  //     ),
  //   },
  //   {
  //     serial: 2,
  //     formTitle: "BRSR",
  //     assignedOn: "01/02/2023",
  //     roleType: "Employee",
  //     action: (
  //       <div className="flex gap-2">
  //         <GreenEye />
  //       </div>
  //     ),
  //   },
  //   {
  //     serial: 3,
  //     formTitle: "COPORATE OFFICE - SCOPE 1 & 2",
  //     assignedOn: "01/02/2023",
  //     roleType: "Employee, Vendor",
  //     action: (
  //       <div className="flex gap-2">
  //         <GreenEye />
  //       </div>
  //     ),
  //   },
  //   {
  //     serial: 4,
  //     formTitle: "COPORATE OFFICE - SCOPE 3",
  //     assignedOn: "05/06/2023",
  //     roleType: "Admin",
  //     action: (
  //       <div className="flex gap-2">
  //         <GreenEye />
  //       </div>
  //     ),
  //   },
  //   {
  //     serial: 5,
  //     formTitle: "EMPLOYEE FORM",
  //     assignedOn: "08/06/2023",
  //     roleType: "Location User, Vendor",
  //     action: (
  //       <div className="flex gap-2">
  //         <GreenEye />
  //       </div>
  //     ),
  //   },
  // ]);

  const getStandardForms = async (projectId) => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_STANDARD_FORM_BY_PROJECTID(projectId, searchItem, pageNo, pageSize),
      });
      if (response.success) {
       const { records, total, limit, pageNo, totalPages } = response.data;

      // ✅ update state with proper backend values
      setPageSize(limit);
      setTotalRecords(total);
      setPageNo(pageNo);
        const data = response.data.records.map((item, index) => ({
        
          key: item._id,
          serial: (pageNo - 1) * limit + (index + 1) ,
          formTitle: item.title,
          assignedOn: formatDate(item.AssignedOn),
          roleType: convertRoleType(item.role_type).join(", "),
          action: (
            <div className="flex gap-3">
              <GreenEye
                style={{ fontSize: "18px", cursor: "pointer" }}
                onClick={() => {
                  navigate(`/standard-forms/${item._id}/all-questions`);
                }}
              />
              {/* <CopyIcon style={{ fontSize: "18px", cursor: "pointer" }} /> */}
            </div>
          ),
        }
      ));
        setTableData(data);
      }
    } catch (error) {
      console.error("Error in fetching standard form data", error);
    }
  };
const handlePageChange = useCallback((page, pageSize) => {
   setPageNo(page);
  setPageSize(pageSize);
}, []);
  useEffect(() => {
    if (projectId) {
      getStandardForms(projectId);
    }
  }, [projectId, searchItem, pageNo, pageSize]);
  return (
    <div>
      <CardsBorder>
        <div>
          <div>
            <div className="px-10 pb-4 flex justify-between">
              <div className="flex gap-16">
                <div className="flex items-center  gap-2 text-xl  font-bold">
                  <TextStyles color="gradient">Standard Forms</TextStyles>
                </div>
                <SearchBar
                  width="400px"
                  onSearch={(value) => {
                    setSearchItem(value);
                    setPageNo(1)
                  }}
                />
              </div>
              {/* <div>
                <CustomButton
                  buttonType="primary"
                  variant="ok"
                  buttonText="Assign Form"
                  className="text-xs h-[45px] px-8"
                  // onClick={handleOpenAddNew}
                />
              </div> */}
            </div>
            <Tables data={tableData} headers={headers} pageSize={pageSize} current={pageNo} total={totalRecords} onChange={handlePageChange} />
          </div>
        </div>
      </CardsBorder>
    </div>
  );
};

export default StandardForms;
